import React from 'react';
import PropTypes from 'prop-types';
import GoogleLogo from 'static/images/svg/google_logo.svg';
import FacebookLogo from 'static/images/svg/facebook_logo.svg';
import LinkedInLogo from 'static/images/svg/linkedin_logo.svg';
import MicrosoftLogo from 'static/images/svg/microsoft_logo.svg';
import LastPassLogo from 'static/images/svg/lastpass_logo.svg';
import AppleLogo from 'static/images/svg/apple_logo.svg';
import { AnchorIntl } from 'components/intl';
import {
  FormattedHTMLMessage,
  FormattedMessage,
  injectIntl,
  defineMessages,
} from 'react-intl';
import classes from './signin-security.scss';
import appconfig from 'config/appconfig';
import st from 'core/shared-translations';

const t = defineMessages({
  'social-accounts.social-accounts': {
    id: 'social-accounts.social-accounts',
    defaultMessage: 'Other ways to sign in',
    description: 'Title string for the Social Accounts section',
  },
  'social-accounts.info-text_line': {
    id: 'social-accounts.info-text_line',
    defaultMessage: 'Save time using an existing account. We promise to use your info only to sign in.',
    description: 'Information string for the Social Accounts section',
  },
  'social-accounts.connected-as': {
    id: 'social-accounts.connected-as',
    defaultMessage: 'Connected as <b>{socialId}</b>',
    description: 'Label text preceding the user\'s email when user is connected to the social account ',
  },
  'social-accounts.disconnect-link': {
    id: 'social-accounts.disconnect-link',
    defaultMessage: 'Disconnect',
    description: 'Link text displayed for disconnecting the user\'s associated social account. ',
  },

});

export const SocialAccounts = ({
  googleEmail,
  googleLink,
  facebookEmail,
  facebookLink,
  linkedinEmail,
  linkedinLink,
  microsoftEmail,
  microsoftLink,
  lastpassEmail,
  lastpassLink,
  appleEmail,
  appleLink,
  disconnectSocialAccount,
}) => (
  <div>
    <div className="row">
      <div id="social-accounts-section-title" className="col-xs-12 sectionTitle">
        <FormattedMessage {...t['social-accounts.social-accounts']} />
      </div>
    </div>
    <div id="social-accounts-text" className={classes['sectionInfo']}>
      <FormattedMessage {...t['social-accounts.info-text_line']} />
    </div>
    <div id="lastpassAccount" className="row">
      <div className="col-xs-2">
        <img className={classes['socialLogo']} src={LastPassLogo} alt="" />
      </div>
      <div className="col-xs-10 no-padding">
        <div id="lastpass-social-label" className={classes['socialLabel']}>
          {lastpassEmail &&
            <FormattedHTMLMessage {...t['social-accounts.connected-as']} values={{socialId: lastpassEmail}} />}
          {!lastpassEmail &&
            <AnchorIntl a={{href: lastpassLink, message: st['shared.connect-to-lastpass'], target: '_self'}} />}
        </div>
        {lastpassEmail &&
          <div id="lastpass-social-disconnect" className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: '#',
                message: t['social-accounts.disconnect-link'],
                target: '_self',
                onClick: disconnectSocialAccount(appconfig.socialAccounts.LASTPASS)}}
            />
          </div>}
      </div>
    </div>
    <div id="googleAccount" className="row">
      <div className="col-xs-2">
        <img
          className={classes['socialLogo']}
          src={GoogleLogo}
          alt=""
        />
      </div>
      <div className="col-xs-10 no-padding">
        <div id="google-social-label" className={classes['socialLabel']}>
          {googleEmail &&
            <FormattedHTMLMessage {...t['social-accounts.connected-as']} values={{socialId: googleEmail}} />}
          {!googleEmail &&
            <AnchorIntl a={{href: googleLink, message: st['shared.connect-to-google'], target: '_self'}} />}
        </div>
        {googleEmail &&
          <div id="google-social-disconnect" className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: '#',
                message: t['social-accounts.disconnect-link'],
                target: '_self',
                onClick: disconnectSocialAccount(appconfig.socialAccounts.GOOGLE)}}
            />
          </div>}
      </div>
    </div>
    <div id="facebookAccount" className="row">
      <div className="col-xs-2">
        <img
          className={classes['socialLogo']}
          src={FacebookLogo}
          alt=""
        />
      </div>
      <div className="col-xs-10 no-padding">
        <div id="facebook-social-label" className={classes['socialLabel']}>
          {facebookEmail &&
            <FormattedHTMLMessage {...t['social-accounts.connected-as']} values={{socialId: facebookEmail}} />}
          {!facebookEmail &&
            <AnchorIntl a={{href: facebookLink, message: st['shared.connect-to-facebook'], target: '_self'}} />}
        </div>
        {facebookEmail &&
          <div id="facebook-social-disconnect" className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: '#',
                message: t['social-accounts.disconnect-link'],
                target: '_self',
                onClick: disconnectSocialAccount(appconfig.socialAccounts.FACEBOOK)}}
            />
          </div>}
      </div>
    </div>
    <div id="linkedinAccount" className="row">
      <div className="col-xs-2">
        <img
          className={classes['socialLogo']}
          src={LinkedInLogo}
          alt=""
        />
      </div>
      <div className="col-xs-10 no-padding">
        <div id="linkedin-social-label" className={classes['socialLabel']}>
          {linkedinEmail &&
            <FormattedHTMLMessage {...t['social-accounts.connected-as']} values={{socialId: linkedinEmail}} />}
          {!linkedinEmail &&
            <AnchorIntl a={{href: linkedinLink, message: st['shared.connect-to-linkedin'], target: '_self'}} />}
        </div>
        {linkedinEmail &&
          <div id="linkedin-social-disconnect" className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: '#',
                message: t['social-accounts.disconnect-link'],
                target: '_self',
                onClick: disconnectSocialAccount(appconfig.socialAccounts.LINKEDIN)}}
            />
          </div>}
      </div>
    </div>
    <div id="microsoftAccount" className="row">
      <div className="col-xs-2">
        <img className={classes['socialLogo']} src={MicrosoftLogo} alt="" />
      </div>
      <div className="col-xs-10 no-padding">
        <div id="microsoft-social-label" className={classes['socialLabel']}>
          {microsoftEmail &&
            <FormattedHTMLMessage {...t['social-accounts.connected-as']} values={{socialId: microsoftEmail}} />}
          {!microsoftEmail &&
            <AnchorIntl a={{href: microsoftLink, message: st['shared.connect-to-microsoft'], target: '_self'}} />}
        </div>
        {microsoftEmail &&
          <div id="microsoft-social-disconnect" className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: '#',
                message: t['social-accounts.disconnect-link'],
                target: '_self',
                onClick: disconnectSocialAccount(appconfig.socialAccounts.MICROSOFT)}}
            />
          </div>}
      </div>
    </div>
    <div id="appleAccount" className="row">
      <div className="col-xs-2">
        <img className={classes['socialLogo']} src={AppleLogo} alt="" />
      </div>
      <div className="col-xs-10 no-padding">
        <div id="apple-social-label" className={classes['socialLabel']}>
          {appleEmail &&
            <FormattedHTMLMessage {...t['social-accounts.connected-as']} values={{socialId: appleEmail}} />}
          {!appleEmail &&
            <AnchorIntl a={{href: appleLink, message: st['shared.connect-to-apple'], target: '_self'}} />}
        </div>
        {appleEmail &&
          <div id="apple-social-disconnect" className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: '#',
                message: t['social-accounts.disconnect-link'],
                target: '_self',
                onClick: disconnectSocialAccount(appconfig.socialAccounts.APPLE)}}
            />
          </div>}
      </div>
    </div>
  </div>
);

SocialAccounts.propTypes = {
  googleEmail: PropTypes.string,
  googleLink: PropTypes.string,
  facebookEmail: PropTypes.string,
  facebookLink: PropTypes.string,
  linkedinEmail: PropTypes.string,
  linkedinLink: PropTypes.string,
  microsoftEmail: PropTypes.string,
  microsoftLink: PropTypes.string,
  lastpassEmail: PropTypes.string,
  lastpassLink: PropTypes.string,
  appleEmail: PropTypes.string,
  appleLink: PropTypes.string,
  disconnectSocialAccount: PropTypes.func.isRequired,
};

export default injectIntl(SocialAccounts);
